package pages.inbound

import ics.materialUI.components.classes.ContentFieldMapping
import interfaces.ListPageFieldMappingInterface

object InboundListPageFieldMappings {
    val headerSequence: Array<String> = arrayOf(
        "recordId",
        "owner",
        "name",
        "statusDescription",
        "internalReference",
        "amountToReceive",
        "amountReceived"
    )
    object FieldMappings {
        val english: Array<ContentFieldMapping> = arrayOf(
            ContentFieldMapping(
                "recordId",
                "Record ID"
            ),
            ContentFieldMapping(
                "owner",
                "Owner"
            ),
            ContentFieldMapping(
                "name",
                "Name"
            ),
            ContentFieldMapping(
                "statusDescription",
                "Status description"
            ),
            ContentFieldMapping(
                "internalReference",
                "Internal ref"
            ),
            ContentFieldMapping(
                "amountToReceive",
                "Amount to receive"
            ),
            ContentFieldMapping(
                "amountReceived",
                "Amount received"
            ),
        )
    }
}